// The site is temporarily offline. See public/index.html for the static
// maintenance page actually shown to visitors.
//
// This component is reduced to a no-op so the React bundle injected by
// CRA into public/index.html can mount cleanly into <div id="root"> without
// rendering anything on top of the static maintenance content above it.
//
// To bring the site back online: `git revert` the offline commit and the
// previous App will be restored byte-for-byte. Cloudflare Pages will
// auto-deploy on push.
function App() {
  return null;
}

export default App;
